// Данные страниц «Доставка и оплата» и «Гарантия, обмен и возврат».
// Текст перенесён ВЕРБАТИМ из исходных страниц — ничего не добавлено и не выдумано,
// только разложено по полям для аккуратной вёрстки.

export interface PaymentMethod {
  name: string;
  fee: string;
  free: boolean;
  note?: string;
}

export const paymentMethods: PaymentMethod[] = [
  { name: "Наличные", fee: "0%", free: true },
  { name: "Безналичный расчёт", fee: "0%", free: true },
  { name: "Безналичный расчёт для юр. лиц", fee: "+3%", free: false, note: "от стоимости заказа" }
];

export interface DeliveryRow {
  label: string;
  value: string;
  free?: boolean;
}

export interface DeliverySection {
  title: string;
  icon: "store" | "truck" | "map";
  rows: DeliveryRow[];
}

export const deliverySections: DeliverySection[] = [
  {
    title: "Самовывоз из магазина",
    icon: "store",
    rows: [
      { label: "Бесплатно", value: "Сегодня — завтра", free: true }
    ]
  },
  {
    title: "Доставка по Москве (в пределах МКАД)",
    icon: "truck",
    rows: [
      { label: "День в день (сегодня)", value: "790 ₽" },
      { label: "Экспресс (4 часа)", value: "1090 ₽" },
      { label: "Супер экспресс (2 часа)", value: "1390 ₽" }
    ]
  },
  {
    title: "Доставка в пределах ЦКАД",
    icon: "map",
    rows: [
      { label: "День в день (сегодня)", value: "790 ₽ + 50 ₽ за каждый км от МКАДа" },
      { label: "Экспресс (4 часа)", value: "1390 ₽ + 50 ₽ за каждый км от МКАДа" }
    ]
  }
];

// ---- Гарантия ----

export const warrantyHeadline = "Гарантийное обслуживание 1&nbsp;год с&nbsp;момента покупки";

export const warrantyParagraphs: string[] = [
  `Продавец обязуется в&nbsp;течение гарантийного срока осуществлять гарантийный ремонт и&nbsp;обслуживание изделия.
   Гарантийное обслуживание не&nbsp;распространяется на&nbsp;повреждения, вызванные неправильным подключением, эксплуатацией в&nbsp;нештатном режиме, а&nbsp;также происшедшим вследствие действия сторонних обстоятельств (скачков напряжения, стихийных бедствий и&nbsp;т.д.). Гарантийное обслуживание не&nbsp;распространяется на&nbsp;механические дефекты и&nbsp;тепловые повреждения устройства. Повреждения процессора, материнской платы и&nbsp;т.д. вследствие &laquo;разгона&raquo; ГАРАНТИИ НЕ&nbsp;ПОДЛЕЖАТ.`,
  `Выпадение точек экрана количеством не&nbsp;более 4-х не&nbsp;является существенным недостатком iPad, iPhone, MacBook, iMac и&nbsp;прочих аппаратов имеющих&nbsp;ЖК дисплей. В&nbsp;соответствии с&nbsp;Законом о&nbsp;защите прав потребителя позднейшая редакция постановления Правительства Российской Федерации &#8470;&nbsp;55&nbsp;от&nbsp;19&nbsp;января 1998&nbsp;г.<br />
   &laquo;Перечень непродовольственных товаров надлежащего качества, не&nbsp;подлежащих возврату или обмену на&nbsp;аналогичный товар других размеров, формы, габарита, фасона, расцветки или комплектации&raquo; (с&nbsp;изменениями на&nbsp;20&nbsp;октября 1998&nbsp;г.).`,
  `А также гарантия не&nbsp;распространяется:<br />
   a. При наличии в&nbsp;изделии следов попытки разбора, ремонта или вмешательства в&nbsp;устройство.<br />
   b. При повреждении устройства или механическом воздействии на&nbsp;устройство.<br />
   c. Если оригинальные заводские номера на устройство уничтожены, повреждены или имеют исправления.`,
  `Причина возникновения дефектов определяют специалисты гарантийного отдела магазина. При несогласии с&nbsp;заключением может быть произведена независимая экспертиза в&nbsp;соответствии с&nbsp;законом о&nbsp;Защите прав потребителей.<br />
   Гарантийное обслуживание мониторов, принтеров, сканеров и&nbsp;любого другого периферийного оборудования, гарантия на&nbsp;которое поддерживается производителем производится в&nbsp;специализированных сервисных центрах с&nbsp;момента покупки. Доставка оборудования на&nbsp;гарантийный ремонт осуществляется силами покупателя.<br />
   Совершение покупки означает согласие покупателя с&nbsp;настоящими правилами.`
];

export const warrantyNote = `Устройство имеет недостаток в&nbsp;виде невозможности предустановки RuStore. ( клиент уведомляется о&nbsp;имеющемся ранееуказанном недостатке перед покупкой, а&nbsp;приобретая устройство клиент автоматически соглашается с&nbsp;имеющимся в&nbsp;купленном устройстве недостатке в&nbsp;виде неустановленного RuStore). Данный недостаток не&nbsp;влияет на&nbsp;другие аспекты работы устройства.`;

// ---- Возврат и обмен ----

export interface ReturnBlock {
  text: string;
  heading?: boolean;
}

export const returnBlocks: ReturnBlock[] = [
  { text: `Мы&nbsp;осуществляем возврат и&nbsp;обмен товаров в&nbsp;соответствии с&nbsp;Законом Российской Федерации &laquo;О&nbsp;защите прав потребителей&raquo;. Возврат или обмен товара надлежащего качества (если товар вам просто не&nbsp;подошёл) Срок: Вы&nbsp;можете вернуть или обменять товар в&nbsp;течение 14&nbsp;дней, не&nbsp;считая дня покупки.` },
  { text: `Условия возврата/обмена: Товар не&nbsp;был в&nbsp;употреблении (отсутствуют следы эксплуатации). Сохранён его товарный вид и&nbsp;потребительские свойства. Сохранена целостность заводской упаковки и&nbsp;полная комплектация. Сохранены фабричные ярлыки и&nbsp;пломбы. Товар не&nbsp;активирован` },
  { text: `Обратите внимание: Наличие любых следов использования может стать причиной отказа в&nbsp;возврате или обмене.` },
  { text: `Для товаров, купленных дистанционно (через интернет): Вы&nbsp;имеете право отказаться от&nbsp;товара в&nbsp;любое время до&nbsp;его получения. После получения товара&nbsp;&mdash; в&nbsp;течение 7&nbsp;дней. Важно: Если при доставке вам не&nbsp;была предоставлена письменная информация о&nbsp;порядке и&nbsp;сроках возврата товара надлежащего качества, срок возврата может быть продлён в&nbsp;соответствии с&nbsp;законодательством (Постановление Правительства РФ&nbsp;от&nbsp;31.12.2020 &#8470;&nbsp;2463).` },
  { text: `Возврат или обмен товара ненадлежащего качества (если обнаружен производственный брак) В&nbsp;течение 14&nbsp;дней (считая день покупки): При обнаружении производственного брака вы&nbsp;вправе потребовать: уплаченной суммы за&nbsp;товар (отказаться от&nbsp;покупки). Обмен товара на&nbsp;аналогичный (той&nbsp;же марки, модели, артикула) или на&nbsp;другой товар с&nbsp;соответствующим перерасчётом цены.` },
  { text: `Мы&nbsp;обязуемся заменить товар в&nbsp;течение 7&nbsp;дней с&nbsp;момента вашего обращения, а&nbsp;при необходимости дополнительной проверки качества&nbsp;&mdash; в&nbsp;течение 45&nbsp;дней.` },
  { text: `После 14&nbsp;дней (для технически сложных товаров):`, heading: true },
  { text: `Требования о&nbsp;возврате или обмене технически сложного товара по&nbsp;истечении 14&nbsp;дней возможны только в&nbsp;следующих случаях: Обнаружен существенный недостаток товара (неустранимый, требующий несоразмерных расходов/времени на&nbsp;устранение, выявляющийся неоднократно или проявляющийся вновь после устранения). Нарушены установленные законом сроки устранения недостатков (сроки ремонта). Товар невозможно использовать в&nbsp;совокупности более 30&nbsp;дней в&nbsp;течение каждого года гарантийного срока из-за многократного устранения различных недостатков.` },
  { text: `Как оформить возврат или обмен:`, heading: true },
  { text: `По&nbsp;вопросам гарантийного обслуживания, обмена или возврата товара, пожалуйста, свяжитесь с&nbsp;нами любым удобным для вас способом из&nbsp;раздела &laquo;Контакты&raquo;.` }
];

export const returnNote = `Устройства имеющие недостаток в&nbsp;виде невозможности предустановки RuStore обмену и&nbsp;возврату не&nbsp;подлежат, кроме вышеперечисленных случаев. Данный недостаток не&nbsp;влияет на&nbsp;другие аспекты работы устройства`;
